module.exports = {"id":"214021","name":"Fáiner Torijano","rating":"71","photo":"./data/images/photos/2/214021.png","club":{"name":"Deportes Tolima","logo":"./data/images/clubs/DeportesTolima.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FainerTorijano0.json
// module id = 1364
// module chunks = 0